// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"120":"kev-widget","410":"carousel-widget","963":"top-vendors-widget"}[chunkId] + ".css";
};